import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';

export interface SettingSpec {
  key: string;
  label: string;
  usedFor: string;
  type: 'TEXT' | 'NUMBER' | 'CHOICE' | 'BOOLEAN' | 'COLUMNS';
  default: string;
  group: string;
  choices?: string[];
  min?: number;
  max?: number;
  maxLength?: number;
}

/**
 * How this shop has chosen to run.
 *
 * Cached for a good while: these change a few times a year, and every printed
 * document asks for them.
 */
export function useSettings(): {
  values: Record<string, string>;
  catalogue: SettingSpec[];
  isLoading: boolean;
  setting: (key: string, fallback?: string) => string;
} {
  const { data, isLoading } = useQuery({
    queryKey: ['settings'],
    queryFn: () => api.get<{ catalogue: SettingSpec[]; values: Record<string, string> }>('/settings'),
    staleTime: 600_000,
  });

  const values = data?.values ?? {};
  return {
    values,
    catalogue: data?.catalogue ?? [],
    isLoading,
    setting: (key, fallback = '') => values[key] ?? fallback,
  };
}
